import { useState, useMemo, useEffect } from "react";
// import { useContext, useCallback } from "react";
// import { SocketContext } from "../context/socket";

// /** Sort copy: tableId ascending, connected descending (truthy before falsy). */
// function sortSocketLogRows(data) {
//    return [...(data || [])].sort((a, b) => {
//       const ta =
//          a.tableId == null ? Number.POSITIVE_INFINITY : Number(a.tableId);
//       const tb =
//          b.tableId == null ? Number.POSITIVE_INFINITY : Number(b.tableId);
//       if (ta !== tb) {
//          return ta - tb;
//       }
//       const ac = Boolean(a.connected);
//       const bc = Boolean(b.connected);
//       if (ac !== bc) {
//          return ac ? -1 : 1;
//       }
//       return 0;
//    });
// }

export default function useConnectedClients() {
   // const socket = useContext(SocketContext);
   const [rows] = useState([]);
   const [loading, setLoading] = useState(false);
   const [error] = useState(null);

   // const applySnapshot = useCallback((data) => {
   //    if (data && typeof data === "object" && !Array.isArray(data) && data.error) {
   //       setError(data.error);
   //       setLoading(false);
   //       return;
   //    }
   //    setError(null);
   //    setRows(sortSocketLogRows(Array.isArray(data) ? data : []));
   //    setLoading(false);
   // }, []);

   // useEffect(() => {
   //    const onSocketLog = (payload) => {
   //       applySnapshot(Array.isArray(payload) ? payload : []);
   //    };

   //    setLoading(true);
   //    socket.emit("subscribeSocketLog", applySnapshot);
   //    socket.on("socketLog", onSocketLog);

   //    return () => {
   //       socket.off("socketLog", onSocketLog);
   //       socket.emit("unsubscribeSocketLog");
   //    };
   // }, [socket, applySnapshot]);

   useEffect(() => {
      setLoading(false);
   }, []);

   const handlers = useMemo(
      () => ({
         refresh: () => {
            // setLoading(true);
            // socket.emit("getSocketLog", applySnapshot);
         },
      }),
      []
   );

   return [rows, { loading, error, refresh: handlers.refresh }];
}
